import App from './App.svelte';
import { overrideItemIdKeyNameBeforeInitialisingDndZones } from 'svelte-dnd-action';
overrideItemIdKeyNameBeforeInitialisingDndZones('index');
export default App;
